export default () => {
  return editor => {
    const notifications = editor.plugins.get('Notification');
    // https://ckeditor.com/docs/ckeditor5/latest/api/module_ui_notification_notification-Notification.html#function-showWarning
    notifications.on('show:warning', (evt, _data) => {
      evt.stop();
    });
  };
};
